import { TermsAndConditions } from '@thehubz/shared/model';

const terms =
  `
  <p class="pt-2 pb-2 m-0">` +
  $localize`:terms and conditions:Please note that all images and videos are subject to copyright and the following terms of use apply` +
  `:</p>
  <ul>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:Photos and videos may only be used for editorial or private purposes` +
  `</li>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:The use for private purposes (e.g. Facebook, Instagram, Websites, etc.) is not permitted` +
  `</li>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:Please note the individually indicated copyright information` +
  `</li>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:Photos and videos may not be distorted or combined with other images or graphics` +
  `</li>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:Images or videos may not be passed on to third parties` +
  `</li>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:Permanent electronic storage is not permitted` +
  `</li>
    <li class="list-disc list-inside p-1">` +
  $localize`:terms and conditions:If the photo or video file has an expiration date, it may not be used after the specified date and must be deleted from any storage medium` +
  `</li>
  </ul>`;

export const termsAndConditions: TermsAndConditions = {
  registration: terms,
  assetDownload: terms,
};
